import * as colors from 'constants/colors';
import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  gap: 10px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  button{
    width: 200px;
  }
`

export const Text = styled.p`
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`

export const Title = styled.h2`
  font-weight: 700;
  font-size: 26px;
  margin-bottom: 10px;
  color: ${colors.primary01};
  text-align: center;
`
export const SubTitle = styled.h4<{
  color: string
}>`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.color};
  strong{
    font-weight: 700;
    font-size: 18px;
  }
`
export const Gratitude = styled.h4`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.primary01};
  text-align: center;
`

export const TextGratitude = styled.p`
  text-align: center;
  font-weight: 600;
`

export const Result = styled.section`
  display: grid;
  gap: 20px;
`

export const ResultItem = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const ResultItemTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.primary01};
`

export const ResultItemDescription = styled.div`
  text-align: justify;
`

export const ResultItemSuggestions = styled.p`
  margin: 5px 0 0 0;
  text-align: justify;
`

export const Footer = styled.div`
  display: grid;
  justify-content: center;
  gap: 10px;
  margin: 30px 0 0 0;
  .avatars{
    margin: 0 auto;
  }
`
export const Logo = styled.img`
  margin: 0 auto 16px;
  display: block;
`
